"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitesList = void 0;
const filter_header_1 = require("client/components/filter-header");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/sites/modules/sites-list/store");
const store_2 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
require("./sites-list.less");
const columns = [
    {
        center: false,
        id: "displayName",
        numeric: false,
        label: "Pharmacy Name"
    },
    {
        center: false,
        id: "city",
        numeric: false,
        label: "Location"
    }
    // {
    //   center: true,
    //   id: "totalClaims",
    //   numeric: false,
    //   label: "Total Claims",
    //   sortable: false
    // },
    // {
    //   center: true,
    //   id: "inventory",
    //   numeric: false,
    //   label: "Inventory",
    //   sortable: false
    // }
];
let SitesList = class SitesList extends react_1.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "name";
        this.filterText = "";
        this.loadSites = throttle_debounce_1.debounce(200, () => {
            store_1.sitesListStore.loadSitesNoRelation({
                count: 100,
                order: this.order,
                search: this.filterText,
                sort: this.orderBy,
                start: 0
            });
        });
        this.onHandleClickAddSite = () => {
            router_1.RouteManager.transitionTo("/pharmacies/0");
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadSites();
        };
        this.onCallback = (value) => {
            this.filterText = value;
            this.loadSites();
        };
        this.onMouseEnter = () => {
            // console.log('onmouseleave');
        };
        this.onMouseLeave = () => {
            // console.log('onmouseleave');
        };
        this.renderTableRow = (row, index) => {
            const siteName = row.displayName || row.name;
            return (React.createElement(list_item_1.MaterialListItem, { key: index, to: `/lots/pharmacies/${row.id}/inventory-lot` },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(siteName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: `${capitalize_string_1.capitalizeString(row.city)}, ${row.state}` })));
        };
        this.renderTable = () => {
            const { sites: { value: sites = [] } } = store_1.sitesListStore;
            let filteredSites = null;
            if (!store_2.usersStore.permissions.ReadInventories) {
                filteredSites = sites.filter((site) => site.id === store_2.usersStore.user.value.siteId);
            }
            return (React.createElement("div", { className: "sites__list" },
                React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: filteredSites ? filteredSites : sites, renderRow: this.renderTableRow, resizableheader: true, customClass: "custom-material-list__sites-list--inventory-lot" })));
        };
    }
    componentWillMount() {
        // sitesListStore.manualTest();
        store_1.sitesListStore.loadSitesNoRelation();
        if (store_2.usersStore &&
            store_2.usersStore.user &&
            store_2.usersStore.user.value &&
            store_2.usersStore.user.value &&
            store_2.usersStore.user.value.siteUser) {
            const siteId = store_2.usersStore.user.value.site.id;
            router_1.RouteManager.transitionTo(`/lots/pharmacies/${siteId}/inventory`);
        }
    }
    render() {
        return (React.createElement("div", { className: "sites" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "sites__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Inventory Lot", subLabel: " " }))),
            React.createElement(floating_page_1.FloatingPage, null, this.renderMain())));
    }
    renderMain() {
        return React.createElement("div", { className: "sites__main" }, this.renderSites());
    }
    renderSites() {
        return (React.createElement("div", { className: "sites__data" },
            React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Pharmacies", callBack: this.onCallback, filterText: this.filterText }),
            this.renderTable()));
    }
};
__decorate([
    mobx_1.observable
], SitesList.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "filterText", void 0);
SitesList = __decorate([
    mobx_react_1.observer
], SitesList);
exports.SitesList = SitesList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-list/sites-list.tsx
// module id = 4123
// module chunks = 0